//Outcomes the library implements, i.e. what a landing does once the CRM has
//the order. A page declaring anything else is left to the legacy bundle, so
//exactly one implementation ever runs.
export const HANDLED_MODAL_TYPES = ["codPaymentRedirect", "codRedirect"];

export function handlesModalType() {
	return (
		typeof window.MODAL_TYPE === "undefined" ||
		HANDLED_MODAL_TYPES.indexOf(window.MODAL_TYPE) !== -1
	);
}

//The COD funnels have no payment step, so the only thing that moves the
//customer off the checkout is the page the CRM names for that landing. The
//page no longer guesses one from its own filename: a thank-you page can then
//be changed, split-tested or given to an affiliate from the CRM alone,
//without touching a landing. Nothing configured means nothing happens - the
//customer stays on the checkout, where the order is already registered, and
//the page's own message is the last thing they read.
export function goToSuccessPage(url) {
	const target = safeTarget(url);

	if (!target) {
		return false;
	}

	window.location.replace(target);
	return true;
}

//The value is CRM configuration, not visitor input, but it still decides
//where a customer lands right after ordering: keep it on this site, so a
//mistyped or tampered row cannot turn a checkout into someone else's page.
function safeTarget(url) {
	if (typeof url !== "string" || !url.trim()) {
		return null;
	}

	const candidate = url.trim();

	//Protocol-relative (//evil.com) reads as same-origin to a naive check.
	if (candidate.slice(0, 2) === "//") {
		return null;
	}

	//A plain path is written from the domain root, the way the CRM stores the
	//landing's own file - the checkout it runs on may sit in a different folder
	//than the page being named, so resolving against the current URL would aim
	//at a folder inside a folder.
	if (candidate.indexOf(":") === -1) {
		return candidate.charAt(0) === "/" ? candidate : "/" + candidate;
	}

	try {
		const resolved = new URL(candidate, window.location.href);
		return resolved.origin === window.location.origin ? resolved.href : null;
	} catch (e) {
		return null;
	}
}
